<template>
    <div class="invoiceCreate">
        <p class="invoice-item-title">抬头信息</p>
        <van-form validate-first @failed="onFailed" @submit="submitForm">
            <van-field required label="抬头类型">
                <template #input>
                    <van-radio-group @change="changeType" v-model="form.type" direction="horizontal">
                        <van-radio :name="2">企业单位</van-radio>
                        <van-radio :name="1">个人/非企业单位</van-radio>
                    </van-radio-group>
                </template>
            </van-field>
            <div class="invoice-title" v-if="form.type == 2">
                <van-field required v-model="form.title" label="发票抬头" @focus="showTitlePick = true" @input="getTitle"
                    placeholder="请输入发票抬头" :rules="[{ required: true }]" />
                <div v-if="showTitlePick == true" class="invoice-title-dropdown">
                    <template v-if="companyList.length > 0">
                        <div class="invoice-title-dropdown-item" @click="companyOnchange(item)" v-for="item in companyList"
                            :key="item.code">
                            {{ item.name }}
                        </div>
                    </template>
                    <template v-if="companyList.length == 0">
                        <div class="invoice-title-dropdown-item">暂无数据</div>
                    </template>
                    <!-- <div class="triangle-up"></div> -->
                </div>
            </div>

            <van-field required disabled v-if="form.type == 2" v-model="form.taxesno" label="税号" placeholder="请输入税号"
                :rules="[{ required: true }]" />

            <van-field required disabled v-if="form.type == 1" v-model="form.title" label="发票抬头"
                @focus="showTitlePick = true" @input="getTitle" placeholder="请输入发票抬头" :rules="[{ required: true }]" />

            <div v-if="!canSubmit">
                <p class="invoice-item-title">内容信息</p>
                <van-field v-model="form.content" label="发票内容" placeholder="请输入发票内容" />
                <van-field v-model="form.money" disabled label="发票金额" placeholder="请输入发票金额" />

                <p class="invoice-item-title">收票方式</p>
                <van-field required v-model="form.email" label="电子邮件" placeholder="请输入电子邮件"
                    :rules="[{ pattern: rules.email.regex, message: '请输入正确电子邮件' }]" />
                <van-field v-model="form.phoneNo" label="短信" placeholder="请输入手机号码"
                    :rules="[{ pattern: rules.phone.regex, message: '请输入正确手机号码' }]" />
            </div>
            <div v-else>
                <p class="invoice-item-title2">开具电子发票</p>
                <van-field v-model="form.title" label="发票抬头" placeholder="请输入发票抬头" />
                <van-field v-model="form.taxesno" label="纳税人识别号" placeholder="请输入纳税人识别号" />
                <van-field v-model="form.money" disabled label="发票金额" placeholder="请输入发票金额" :rules="[{ required: true }]" />
                <van-field v-model="form.email" label="邮箱" placeholder="请输入邮箱" />
                <van-field v-model="form.phoneNo" label="手机号码" placeholder="请输入手机号码" />
                <p class="invoiceCreate-tips">温馨提示：发票开具成功后不可撤销，请您仔细核对开票信息</p>
            </div>
            <div class="invoice-btn-wrap" v-if="!canSubmit">
                <van-button round block color="#009AF3 " class="comfirm-btn">提交</van-button>
            </div>
        </van-form>
        <div class="invoice-btn-wrap" v-if="canSubmit">
            <div class="flex justify-between">
                <van-button class="invoice-btn-submit" block plain color="#009AF3 "
                    @click="canSubmit = false">重新填写</van-button>
                <van-button class="invoice-btn-submit" block color="#009AF3 " @click="submitForm">确认提交</van-button>
            </div>
        </div>
    </div>
</template>

<script>
import rules from "@/libs/fieldValidateRules";
import { selectContentByOrderType, selectCodeByTitle, selectTaxByCode, registerInvoice } from "@/api/index";
import { debounce } from "@/libs/tools";
import { DropdownItem, DropdownMenu } from "vant";
export default {
    name: "InvoiceCreate",
    components: {
        "van-dropdown-menu": DropdownMenu,
        "van-dropdown-item": DropdownItem,
    },
    data() {
        return {
            rules,
            canSubmit: false, //是否是重新提交
            showTitlePick: false,
            form: {
                orderType: 2, //订单类型 1：充值订单 2：临停订单 8：月卡订单
                type: 2, // 抬头类型  1:企业,2:个人
                title: "", //抬头
                taxesno: "", //税号
                orderType: 2, //订单类型
                content: "",
                email: "", //电子邮箱
                phoneNo: "", //手机号
                money: 0,
            },
            invoiceArr: [], //所选的订单
            titleList: [], //抬头列表
            companyList: [],
        };
    },
    mounted() {
        // 第一次
        if (!this.canSubmit) {
            this.getContentType();
            this.invoiceArr = this.$route.params.invoiceArr;
            console.log(this.invoiceArr);
            this.form.money = this.invoiceArr.reduce((pre, current) => {
                return parseFloat((+pre + +current.realMoney).toFixed(10));
            }, 0);
        }
        //重新发起
        if (this.canSubmit) {
        }
    },

    methods: {
        //获取发票内容
        getContentType() {
            let obj = {
                orderType: 2, //2和6临停车费  8：月卡  1:充值
            };
            selectContentByOrderType(obj).then((res) => {
                this.form.content = res.data;
            });
        },
        //获取发票title
        getTitle: debounce(function (value) {
            if (value.length >= 3) {
                selectCodeByTitle({ q: value }).then((res) => {
                    this.companyList = res.data;
                });
            }
        }, 500),
        //提交订单
        submitForm() {
            // 第一次
            if (!this.canSubmit) {
                let obj = { ...this.form };
                obj.orderList = this.invoiceArr.map((item) => {
                    return {
                        invoiceMoney: item.realMoney,
                        orderCode: item.orderCode,
                        parkRecordId: item.parkingRecordId,
                        parkCode: item.parkCode,
                    };
                });

                registerInvoice(obj).then((res) => {
                    this.$router.push({ name: "InvoiceSuccess", params: { fpqqlsh: res.data } });

                    // this.$router.push({ name: "InvoiceSuccess", params: { fpqqlsh: 1 } });
                });
            }
            // 重新提交
            else {
            }
        },
        onFailed(errorInfo) {
            console.log("failed", errorInfo);
        },
        companyOnchange(item) {
            selectTaxByCode({ code: item.code }).then((res) => {
                this.form.taxesno = res.data.code;
                this.form.title = item.name;
                this.showTitlePick = false;
            });
        },

        changeType(value) {
            if (value == 1) {
                this.form.title = this.form.content;
                this.form.taxesno = "";
            } else {
                this.form.title = "";
            }
        },
    },
};
</script>

<style lang="less" scoped>
.invoiceCreate {
    .invoice-item-title {
        font-size: 26px;
        color: #33333380;
        padding: 20px 30px;
    }

    .invoice-item-title2 {
        color: #333333;
        text-align: center;
        font-size: 28px;
        padding: 28px;
    }

    .invoiceCreate-tips {
        font-size: 24px;
        color: #ff0000;
        padding: 24px 30px;
    }

    .invoice-btn-wrap {
        padding: 16px;
        background-color: #fff;
        margin-top: 16px;

        .invoice-btn-submit {
            width: 46%;
            border-radius: 16px;
            height: 72px;
        }
    }
}

.invoice-title {
    position: relative;

    .triangle-up {
        // position: absolute;
        left: 200px;
        top: 68px;
        width: 0;
        height: 0;
        border-left: 12px solid transparent;
        border-right: 12px solid transparent;
        border-bottom: 20px solid #ebedf0;
    }

    .invoice-title-dropdown {
        background-color: #fff;
        overflow-y: auto;
        position: absolute;
        left: 200px;
        top: 100px;
        box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);
        z-index: 10;
        max-height: 500px;
        width: 500px;

        color: #646566;

        .invoice-title-dropdown-item {
            height: 60px;
            width: 90%;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            border-bottom: 0.25px #ebedf0 solid;
        }

        .invoice-title-dropdown-item:active {
            background-color: rgb(224, 224, 224);
        }
    }
}</style>
